<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">
      <div v-if="(apiLoaded && report && config) || errorText">
        <div v-if="apiLoaded && report && config" class="wrap">
          <a @click="$router.go(-1)" class="back-link">
            <v-icon class="icon-item icon-chevron-left"></v-icon>
            Назад
          </a>
          <v-row>
            <v-col cols="9">
              <h1>{{ config.title }}</h1>
            </v-col>
            <v-col cols="3">
              <h1 class="mb-3">
                <div class="badge" style="width: 100%">
                  {{ isPreview ? 'Новая' : reportStatuses[report.status] }}
                </div>
              </h1>

              <div v-if="isPreview && canEdit" style="text-align: right">
                <v-btn
                    @click="startFilling"
                    :loading="creating"
                    :disabled="creating"
                    class="mb-3"
                >
                  Начать заполнение
                </v-btn>
              </div>

              <v-dialog
                  v-if="canView"
                  v-model="exportDialog"
                  max-width="500px"
                  persistent
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on" style="text-align: right">
                    <v-btn small outlined class="mb-3">
                      <v-icon class="mr-2" dense>
                        mdi-tray-arrow-up
                      </v-icon>
                      Экспорт
                    </v-btn>
                  </div>
                </template>
                <div v-if="report">
                  <StandardReportExportDialog
                      v-if="report"
                      :report="report"
                      :key="exportDialogKey"
                      @close="exportDialog = false; exportDialogKey++"
                  />
                </div>
              </v-dialog>

              <template v-if="!isPreview">
                <v-dialog
                    v-if="canEdit"
                    v-model="importDialog"
                    max-width="600px"
                    persistent
                >
                  <template v-slot:activator="{ on }">
                    <div style="text-align: right">
                      <v-btn
                          v-on="on"
                          :disabled="report.status === 'SENT'"
                          small
                          outlined
                          class="mb-3"
                      >
                        <v-icon class="mr-2" dense>
                          mdi-tray-arrow-down
                        </v-icon>
                        Импорт
                      </v-btn>
                    </div>
                  </template>
                  <div v-if="report && config">
                    <StandardReportImportDialog
                        :report="report"
                        :config="config"
                        :key="importDialogKey"
                        @close="importDialog = false; importDialogKey++; initialize();"
                    />
                  </div>
                </v-dialog>

                <div style="text-align: right">
                  <v-btn
                      v-if="report.status === 'SENT' && canReturnToDraft"
                      @click="draftDialog = true"
                      small
                      outlined
                  >
                    Вернуть на черновик
                  </v-btn>
                </div>
              </template>
            </v-col>
          </v-row>

          <div v-if="report.returnReason">
            <div>
              <span class="font-weight-bold">Причина возврата:</span> {{ report.returnReason }}
            </div>
          </div>
          <h3>{{ config.shortTitle }}</h3>
          <span>Код отчетной формы: {{ config.context }}</span><br>
          <div class="report-description" v-html="config.description"></div>
          <h4 v-if="($user.role !== 'ROLE_CZN_TERRITORIAL')" style="margin-top: 15px">Респондент: {{ getLevelName() }}</h4>

          <div class="manual-link">
            <div v-for="attachment in attachments" :key="attachment.id">
              <a @click="downloadAttachment(attachment)" download>
                <v-icon class="icon-item icon-file-document-outline"></v-icon>
                {{ truncateStr(attachment.name, 50) }}
              </a>
            </div>
          </div>

          <div class="list passport">
            <div v-for="(section, sectionIndex) in config.sections" :key="'section_' + sectionIndex" class="list-item-wrap">
              <v-expansion-panels>
                <v-expansion-panel :key="'vep' + sectionIndex">
                  <v-expansion-panel-header expand-icon="">
                    <div class="list-item">
                      <a class="list-item-name">
                        <button class="toggleSwitch">
                          <svg class="closed" fill="none" height="24" viewBox="0 0 24 24" width="24"
                               xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 14.5L17 9.5L7 9.5L12 14.5Z" fill="#1551D0"/>
                          </svg>
                          <svg class="opened" fill="none" height="24" viewBox="0 0 24 24" width="24"
                               xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.5 12L9.5 7L9.5 17L14.5 12Z" fill="#1551D0"/>
                          </svg>
                        </button>
                        <span>{{ sectionIndex + 1 }}. {{ section.name }}</span>
                      </a>
                      <v-progress-circular
                          :rotate="-90"
                          :size="50"
                          :value="getProgress(sectionIndex)"
                          :width="6"
                          color="#0033A0">
                        {{ getProgress(sectionIndex) }}
                      </v-progress-circular>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-expansion-panels>
                      <v-expansion-panel v-for="(indicator, indicatorIndex) in section.indicators"
                                         :key="sectionIndex + '.' + indicatorIndex + '.'" class="level2">
                        <div class="list-item-wrap">
                          <v-expansion-panel-header @keyup.space.prevent expand-icon="">
                            <div class="list-item">
                              <a class="list-item-name">
                                <button class="toggleSwitch whiteBg">
                                  <svg class="closed" fill="none" height="24" viewBox="0 0 24 24" width="24"
                                       xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 14.5L17 9.5L7 9.5L12 14.5Z" fill="#1551D0"/>
                                  </svg>
                                  <svg class="opened" fill="none" height="24" viewBox="0 0 24 24" width="24"
                                       xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.5 12L9.5 7L9.5 17L14.5 12Z" fill="#1551D0"/>
                                  </svg>
                                </button>
                                <span>{{ sectionIndex + 1 }}.{{ indicatorIndex + 1 }}. {{ indicator.name }}</span>
                                <StandardReportEditDialog
                                    v-if="canEditDraft"
                                    :report="report"
                                    :indicator="indicator"
                                    :values="getValuesByIndicator(indicator)"
                                    @updated="initialize"/>
                              </a>
                            </div>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <table>
                              <thead>
                              <tr>
                                <th>Параметр</th>
                                <th>Данные</th>
                              </tr>
                              </thead>
                              <template v-if="indicator.isGroup">
                                <tbody v-for="group in getGroups(indicator)" :key="`group${group}`">
                                <tr class="group">
                                  <td>Группа ответов {{ group }}</td>
                                  <td></td>
                                </tr>
                                <tr v-for="(parameter, parameterIndex) in indicator.parameters" :key="`group${group}-${parameter.id}`">
                                  <td style="width: 300px;">
                                    <div>
                                      {{ sectionIndex + 1 }}.{{ indicatorIndex + 1 }}.{{ group }}.{{ parameterIndex + 1 }}. {{ parameter.name }}
                                    </div>
                                    <span v-if="parameter.isFileNeeded || parameter.type === 'FILE'">
                                        <template v-if="!getGroupValue(parameter.id, group - 1, 'FILES')">
                                          Необходимо прикрепить файл
                                        </template>
                                      </span>
                                    <span v-else>
                                        <template v-if="!getGroupValue(parameter.id, group - 1) && !getGroupValue(parameter.id, group - 1, 'FILES')">
                                          Необходимо указать значение параметра или прикрепить файл
                                        </template>
                                      </span>
                                  </td>
                                  <td>
                                    <div>
                                      <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.94029 5.78581C8.59471 5.78581 8.31597 6.05336 8.31597 6.39919V15.4626C8.31597 16.388 7.98158 17.146 7.33488 17.7927C6.68819 18.4394 5.91905 18.7738 4.98271 18.7738C4.06847 18.7738 3.28814 18.4505 2.64147 17.8039C1.99481 17.1572 1.67158 16.3769 1.67158 15.4626V12.0402V10.2119V5.7078V3.54518V3.5228V3.50045C1.67158 2.88732 1.89728 2.35505 2.32943 1.91742C2.76705 1.47434 3.29908 1.23745 3.93481 1.23745C4.57031 1.23745 5.10259 1.47434 5.53993 1.91742C5.97208 2.35505 6.19781 2.88732 6.19781 3.50045V3.5228V3.5673V13.6791C6.19781 14.3143 5.70738 14.805 5.0719 14.805C4.45875 14.805 3.95693 14.2922 3.95693 13.6791V8.38343C3.95693 8.03785 3.68935 7.7703 3.3438 7.7703C2.99824 7.7703 2.73067 8.03785 2.73067 8.38343V13.6791C2.73067 14.3367 2.95375 14.8942 3.41064 15.3513C3.86776 15.8084 4.41408 16.0313 5.07193 16.0313C5.72953 16.0313 6.28152 15.8027 6.74413 15.3513C7.19579 14.9106 7.42413 14.3591 7.42413 13.6791V3.5228V3.50045C7.42413 2.54174 7.07569 1.71955 6.39857 1.03672C5.71572 0.348182 4.89352 0 3.93481 0C2.97587 0 2.15367 0.348182 1.47084 1.03672C0.793747 1.71955 0.445312 2.54174 0.445312 3.50045V3.5228V5.7078V10.2119V12.0402V15.4626C0.445312 16.7224 0.891247 17.7927 1.77195 18.6733C2.65266 19.554 3.72289 20 4.98271 20C6.24254 20 7.33488 19.5764 8.22678 18.6845C9.11865 17.7927 9.55342 16.7003 9.55342 15.4626V6.39919C9.55342 6.05336 9.28584 5.78581 8.94029 5.78581Z" fill="#777779"/>
                                      </svg>
                                      <template v-if="getGroupValue(parameter.id, group - 1, 'FILES')">
                                        <a @click="downloadAttachment(getGroupValue(parameter.id, group - 1, 'FILES'))">
                                          {{ truncateStr(getGroupValue(parameter.id, group - 1, 'FILES')?.name, 50) }}
                                        </a>
                                      </template>
                                      <template v-else>
                                        <span>—</span>
                                      </template>
                                    </div>
                                    <div>
                                      <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.8906 1.45847e-06H2.10938C1.54993 1.45847e-06 1.01341 0.172853 0.617822 0.480529C0.222237 0.788206 0 1.20551 0 1.64063L0 8.70297C0 9.13809 0.222237 9.55539 0.617822 9.86307C1.01341 10.1707 1.54993 10.3436 2.10938 10.3436H5.38312C5.42042 10.3436 5.45619 10.3551 5.48256 10.3756C5.50893 10.3961 5.52375 10.424 5.52375 10.453V13.2344C5.52374 13.3858 5.58146 13.5338 5.68962 13.6598C5.79779 13.7857 5.95153 13.8838 6.13141 13.9418C6.31129 13.9997 6.50923 14.0149 6.70019 13.9853C6.89115 13.9558 7.06655 13.8829 7.20422 13.7758L11.5748 10.3764C11.588 10.3663 11.6036 10.3583 11.6207 10.3528C11.6378 10.3474 11.6562 10.3446 11.6747 10.3447H15.8934C16.4529 10.3447 16.9894 10.1718 17.385 9.86416C17.7806 9.55648 18.0028 9.13919 18.0028 8.70406V1.64063C18.0028 1.42499 17.9482 1.21147 17.842 1.01228C17.7358 0.813088 17.5802 0.63213 17.384 0.479755C17.1878 0.327381 16.955 0.206579 16.6987 0.124258C16.4425 0.0419378 16.1679 -0.000286054 15.8906 1.45847e-06V1.45847e-06ZM17.1562 8.70297C17.1562 8.96404 17.0229 9.21442 16.7856 9.39903C16.5482 9.58364 16.2263 9.68735 15.8906 9.68735H11.6719C11.4118 9.68588 11.1615 9.76452 10.9758 9.9061L6.60938 13.3109C6.58971 13.3264 6.56458 13.3369 6.53719 13.3412C6.5098 13.3454 6.4814 13.3433 6.4556 13.3349C6.42981 13.3266 6.40778 13.3125 6.39234 13.2944C6.3769 13.2763 6.36874 13.255 6.36891 13.2333V10.453C6.36891 10.2499 6.2652 10.0552 6.08059 9.91159C5.89598 9.76801 5.6456 9.68735 5.38453 9.68735H2.10938C1.77371 9.68735 1.45179 9.58364 1.21444 9.39903C0.977092 9.21442 0.84375 8.96404 0.84375 8.70297V1.64063C0.84375 1.37955 0.977092 1.12917 1.21444 0.944568C1.45179 0.759962 1.77371 0.656252 2.10938 0.656252H15.8906C16.2263 0.656252 16.5482 0.759962 16.7856 0.944568C17.0229 1.12917 17.1562 1.37955 17.1562 1.64063V8.70297Z" fill="#777779"/>
                                      </svg>
                                      {{ formatValue(parameter, getGroupValue(parameter.id, group - 1)) }}
                                    </div>
                                    <div style="color: #777779; font-size: 12px" v-if="parameter.recommendedEndDate">
                                      Отчётная дата: {{ parameter.recommendedEndDate | dateFormat }}
                                    </div>
                                    <div style="color: #777779; font-size: 12px">
                                      Дата изменения параметра в группах: {{ getLastUpdatedDateTime(parameter) | dateFormat }}
                                    </div>
                                  </td>
                                </tr>
                                </tbody>
                              </template>
                              <template v-else>
                                <tbody>
                                <tr v-for="(parameter, parameterIndex) in indicator.parameters" :key="parameter.id">
                                  <td style="width: 300px;">
                                    <div>
                                      {{ sectionIndex + 1 }}.{{ indicatorIndex + 1 }}.{{ parameterIndex + 1 }}. {{ parameter.name }}
                                    </div>
                                    <span v-if="parameter.isFileNeeded || parameter.type === 'FILE'">
                                        <template v-if="!getAttachment(parameter.id)">
                                          Необходимо прикрепить файл
                                        </template>
                                      </span>
                                    <span v-else>
                                        <template v-if="!getValue(parameter.id, 'VALUE')?.value && !getAttachment(parameter.id)">
                                          Необходимо указать значение параметра или прикрепить файл
                                        </template>
                                      </span>
                                  </td>
                                  <td>
                                    <div>
                                      <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.94029 5.78581C8.59471 5.78581 8.31597 6.05336 8.31597 6.39919V15.4626C8.31597 16.388 7.98158 17.146 7.33488 17.7927C6.68819 18.4394 5.91905 18.7738 4.98271 18.7738C4.06847 18.7738 3.28814 18.4505 2.64147 17.8039C1.99481 17.1572 1.67158 16.3769 1.67158 15.4626V12.0402V10.2119V5.7078V3.54518V3.5228V3.50045C1.67158 2.88732 1.89728 2.35505 2.32943 1.91742C2.76705 1.47434 3.29908 1.23745 3.93481 1.23745C4.57031 1.23745 5.10259 1.47434 5.53993 1.91742C5.97208 2.35505 6.19781 2.88732 6.19781 3.50045V3.5228V3.5673V13.6791C6.19781 14.3143 5.70738 14.805 5.0719 14.805C4.45875 14.805 3.95693 14.2922 3.95693 13.6791V8.38343C3.95693 8.03785 3.68935 7.7703 3.3438 7.7703C2.99824 7.7703 2.73067 8.03785 2.73067 8.38343V13.6791C2.73067 14.3367 2.95375 14.8942 3.41064 15.3513C3.86776 15.8084 4.41408 16.0313 5.07193 16.0313C5.72953 16.0313 6.28152 15.8027 6.74413 15.3513C7.19579 14.9106 7.42413 14.3591 7.42413 13.6791V3.5228V3.50045C7.42413 2.54174 7.07569 1.71955 6.39857 1.03672C5.71572 0.348182 4.89352 0 3.93481 0C2.97587 0 2.15367 0.348182 1.47084 1.03672C0.793747 1.71955 0.445312 2.54174 0.445312 3.50045V3.5228V5.7078V10.2119V12.0402V15.4626C0.445312 16.7224 0.891247 17.7927 1.77195 18.6733C2.65266 19.554 3.72289 20 4.98271 20C6.24254 20 7.33488 19.5764 8.22678 18.6845C9.11865 17.7927 9.55342 16.7003 9.55342 15.4626V6.39919C9.55342 6.05336 9.28584 5.78581 8.94029 5.78581Z" fill="#777779"/>
                                      </svg>
                                      <template v-if="getAttachment(parameter.id)">
                                        <a @click="downloadAttachment(getAttachment(parameter.id))">
                                          {{ truncateStr(getAttachment(parameter.id)?.name, 50) }}
                                        </a>
                                      </template>
                                      <template v-else>
                                        <span>—</span>
                                      </template>
                                    </div>
                                    <div>
                                      <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.8906 1.45847e-06H2.10938C1.54993 1.45847e-06 1.01341 0.172853 0.617822 0.480529C0.222237 0.788206 0 1.20551 0 1.64063L0 8.70297C0 9.13809 0.222237 9.55539 0.617822 9.86307C1.01341 10.1707 1.54993 10.3436 2.10938 10.3436H5.38312C5.42042 10.3436 5.45619 10.3551 5.48256 10.3756C5.50893 10.3961 5.52375 10.424 5.52375 10.453V13.2344C5.52374 13.3858 5.58146 13.5338 5.68962 13.6598C5.79779 13.7857 5.95153 13.8838 6.13141 13.9418C6.31129 13.9997 6.50923 14.0149 6.70019 13.9853C6.89115 13.9558 7.06655 13.8829 7.20422 13.7758L11.5748 10.3764C11.588 10.3663 11.6036 10.3583 11.6207 10.3528C11.6378 10.3474 11.6562 10.3446 11.6747 10.3447H15.8934C16.4529 10.3447 16.9894 10.1718 17.385 9.86416C17.7806 9.55648 18.0028 9.13919 18.0028 8.70406V1.64063C18.0028 1.42499 17.9482 1.21147 17.842 1.01228C17.7358 0.813088 17.5802 0.63213 17.384 0.479755C17.1878 0.327381 16.955 0.206579 16.6987 0.124258C16.4425 0.0419378 16.1679 -0.000286054 15.8906 1.45847e-06V1.45847e-06ZM17.1562 8.70297C17.1562 8.96404 17.0229 9.21442 16.7856 9.39903C16.5482 9.58364 16.2263 9.68735 15.8906 9.68735H11.6719C11.4118 9.68588 11.1615 9.76452 10.9758 9.9061L6.60938 13.3109C6.58971 13.3264 6.56458 13.3369 6.53719 13.3412C6.5098 13.3454 6.4814 13.3433 6.4556 13.3349C6.42981 13.3266 6.40778 13.3125 6.39234 13.2944C6.3769 13.2763 6.36874 13.255 6.36891 13.2333V10.453C6.36891 10.2499 6.2652 10.0552 6.08059 9.91159C5.89598 9.76801 5.6456 9.68735 5.38453 9.68735H2.10938C1.77371 9.68735 1.45179 9.58364 1.21444 9.39903C0.977092 9.21442 0.84375 8.96404 0.84375 8.70297V1.64063C0.84375 1.37955 0.977092 1.12917 1.21444 0.944568C1.45179 0.759962 1.77371 0.656252 2.10938 0.656252H15.8906C16.2263 0.656252 16.5482 0.759962 16.7856 0.944568C17.0229 1.12917 17.1562 1.37955 17.1562 1.64063V8.70297Z" fill="#777779"/>
                                      </svg>
                                      {{ formatValue(parameter, getValue(parameter.id, 'VALUE')?.value) }}
                                    </div>
                                    <div style="color: #777779; font-size: 12px" v-if="parameter.recommendedEndDate">
                                      Отчётная дата: {{ parameter.recommendedEndDate | dateFormat }}
                                    </div>
                                    <div style="color: #777779; font-size: 12px">
                                      Дата изменения: {{ getLastUpdatedDateTime(parameter) | dateFormat }}
                                    </div>
                                  </td>
                                </tr>
                                </tbody>
                              </template>
                            </table>
                          </v-expansion-panel-content>
                        </div>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
          <v-btn
              v-if="canEditDraft"
              class="push-right"
              @click="sendReport"
              type="button"
          >
            Отправить<br/>на рассмотрение
          </v-btn>
        </div>
        <div v-if="errorText != null" class="error" style="position: fixed;bottom: 0">
          Ошибка: {{ errorText }}
        </div>
      </div>
      <div v-else style="height:1000px"></div>
    </transition>
    <LoaderDialog :show="loading" msg="Загрузка"></LoaderDialog>
    <v-dialog v-model="draftDialog" :key="draftDialog" max-width="500">
      <v-card>
        <v-card-title>
          <span class="text-h5">Вернуть на черновик</span>
        </v-card-title>
        <v-card-text>
          <div><span class="text-subtitle-1">Причина отправки на черновик:</span></div>
          <v-textarea v-model="returnReason" type="text"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="draftDialog = false; draftDialogKey++">Отмена</v-btn>
          <v-btn @click="sendToDraft">Отправить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import StandardReportEditDialog from "@/components/standard_report/StandardReportEditDialog.vue";
import StandardReportExportDialog from "@/components/standard_report/StandardReportExportDialog.vue";
import StandardReportImportDialog from "@/components/standard_report/StandardReportImportDialog.vue";
import {reportStatuses} from "@/modules/ApplicationRepository";
import {getFormById, saveForm} from "@/modules/api.forms";
import {getDomainConfigs} from "@/modules/api.configs";
import {getIndicatorsByContextAndIndicatorId, getIndicatorsByIndicatorFormId} from "@/modules/api.indicators";
import {downloadFile} from "@/modules/api.files";
import LoaderDialog from "@/components/elements/LoaderDialog.vue";
import { StandardReportPermissions } from '@/modules/standardReportPermissions';

export default {
  name: 'StandardReport',
  components: {
    StandardReportEditDialog,
    StandardReportExportDialog,
    StandardReportImportDialog,
    LoaderDialog,
  },
  data: () => ({
    domain: 'standard_report',
    report: null,
    config: null,
    attachments: [],
    attachmentsIndicatorId: 'bfa515de-5c54-4d7b-85d5-07bb9d40a17d',
    values: [],
    apiLoaded: false,
    errorText: null,
    draftDialog: false,
    draftDialogKey: 0,
    exportDialog: false,
    exportDialogKey: 0,
    importDialog: false,
    importDialogKey: 0,
    loading: false,
    creating: false,
    reportStatuses: reportStatuses,
    returnReason: ''
  }),
  computed: {
    isPreview() {
      return this.$route.path === '/reports/preview'
    },
    permissions() {
      return new StandardReportPermissions(this.$user, this.$cznDepartmentsByRegionList)
    },
    canView() {
      return this.permissions.canView(this.report)
    },
    canEdit() {
      return this.permissions.canEdit(this.report)
    },
    canEditDraft() {
      return !this.isPreview && this.report?.status === 'DRAFT' && this.canEdit
    },
    canReturnToDraft() {
      return this.permissions.canReturnToDraft()
    },
  },
  methods: {
    async initialize() {
      this.apiLoaded = false
      this.loading = true
      this.errorText = null

      if (this.isPreview) {
        const query = this.$route.query
        this.report = {
          context: query.context,
          regionCode: query.regionCode || null,
          cznId: query.cznId != null && query.cznId !== '' ? Number(query.cznId) : null,
          status: null,
        }
        if (!this.canView) {
          this.errorText = 'Недостаточно прав для просмотра отчетной формы'
          this.report = null
          this.config = null
          this.loading = false
          this.apiLoaded = true
          return
        }
        this.values = []
        await this.loadConfig()
        await this.loadAttachments()
      } else {
        const reportId = this.$route.params.id
        this.report = (await getFormById(reportId)).payload
        if (!this.canView) {
          this.errorText = 'Недостаточно прав для просмотра отчетной формы'
          this.report = null
          this.config = null
          this.loading = false
          this.apiLoaded = true
          return
        }
        await this.loadConfig()
        await this.loadAttachments()
        await this.loadValues()
      }

      this.loading = false
      this.apiLoaded = true
    },
    async startFilling() {
      if (this.creating || !this.canEdit) {
        return
      }
      this.creating = true
      this.loading = true
      try {
        const report = await saveForm({
          domain: {
            code: this.domain,
          },
          context: this.report.context,
          regionCode: this.report.regionCode,
          cznId: this.report.cznId,
          status: 'DRAFT',
        })
        if (report) {
          await this.$router.replace(`/reports/${report.payload.id}`)
          await this.initialize()
        }
      } catch (error) {
        alert('Ошибка при создании отчетной формы')
        console.error(error)
      } finally {
        this.creating = false
        this.loading = false
      }
    },
    async loadConfig() {
      const result = await getDomainConfigs(this.domain);
      const found = result?.payload?.find(cfg => cfg?.content?.context === this.report.context);
      if (found) {
        const { id, content } = found;
        this.config = { id, ...content };
      }
    },
    async loadAttachments() {
      const value = (await getIndicatorsByContextAndIndicatorId(
          this.domain,
          this.config.context,
          this.attachmentsIndicatorId)).payload
      if (value && value.length && value[0].value) {
        this.attachments = JSON.parse(value[0].value)
      }
    },
    async loadValues() {
      this.values = (await getIndicatorsByIndicatorFormId(this.report.id)).payload
    },
    async sendToDraft() {
      const response = await saveForm({ ...this.report, status: 'DRAFT', returnReason: this.returnReason });
      if (response.ok) {
        await this.$postFormDataApi("/notifs/notifyUser", {
          userName: response.payload.lastModifiedBy,
          text: `Информируем Вас о том, что отчетная форма ${this.config.title} была возвращена на статус «Черновик» по следующей причине: ${this.returnReason}`,
          title: 'Отчёт возвращён на черновик'
        })
        this.draftDialog = false
        this.returnReason = ''
        await this.initialize()
      }
    },
    getValue(parameterId, type) {
      return this.values.find(e => e.indicatorId === parameterId && e.type === type)
    },
    getAttachment(parameterId) {
      const attachmentsJson = this.getValue(parameterId, 'FILES')
      return attachmentsJson && attachmentsJson !== '[]' ? JSON.parse(attachmentsJson.value)[0] : null
    },
    async downloadAttachment(attachment) {
      this.loading = true
      await downloadFile(attachment.id, attachment.name)
      this.loading = false
    },
    getLastUpdatedDateTime(parameter) {
      const value = this.getValue(parameter.id, "VALUE")?.updatedDateTime;
      const attachment = this.getValue(parameter.id, "FILES")?.updatedDateTime;

      if (value && attachment) {
        return new Date(Math.max(new Date(value).getTime(), new Date(attachment).getTime()));
      } else if (value) {
        return new Date(value);
      } else if (attachment) {
        return new Date(attachment);
      }

      return null
    },
    getGroups(indicator) {
      let maxLength = 1;
      for (const parameter of indicator.parameters) {
        ['VALUE', 'FILES'].forEach(type => {
          const record = this.getValue(parameter.id, type);
          const array = this.readArray(record?.value);
          const last = this.lastFilledIndex(array, type);
          if (last >= 0) maxLength = Math.max(maxLength, last + 1);
        });
      }
      return Math.max(maxLength, 1);
    },
    getGroupValue(parameterId, index, type = 'VALUE') {
      const record = this.getValue(parameterId, type);
      const array = this.readArray(record?.value);
      return array[index] ?? null;
    },
    lastFilledIndex(array, type) {
      if (!Array.isArray(array) || !array.length) return -1;
      for (let i = array.length - 1; i >= 0; i--) {
        if (this.isFilledCell(array[i], type)) return i;
      }
      return -1;
    },
    isFilledCell(item, type) {
      return type === 'FILES'
          ? (item != null && item !== '[]')
          : (item != null && item !== '');
    },
    getProgress(sectionIndex) {
      return Math.round(
          (this.getSectionValuesPresent(sectionIndex) /
              this.getSectionValuesCount(sectionIndex)) *
          100
      );
    },
    isGroupCellFilled(parameter, groupIndex) {
      if (parameter.isFileNeeded || parameter.type === 'FILE') {
        return !!this.getGroupValue(parameter.id, groupIndex, 'FILES');
      }
      const hasFile = !!this.getGroupValue(parameter.id, groupIndex, 'FILES');
      const val = this.getGroupValue(parameter.id, groupIndex, 'VALUE');
      const hasValue = val != null && val !== '';
      return hasFile || hasValue;
    },
    isSingleCellFilled(parameter) {
      if (parameter.isFileNeeded || parameter.type === 'FILE') {
        return !!this.getAttachment(parameter.id);
      }
      const hasFile = !!this.getAttachment(parameter.id);
      const val = this.getValue(parameter.id, 'VALUE')?.value;
      const hasValue = val != null && val !== '';
      return hasFile || hasValue;
    },
    getSectionValuesPresent(sectionIndex) {
      let filled = 0;
      const section = this.config.sections[sectionIndex];

      for (const indicator of section.indicators) {
        if (indicator.isGroup) {
          const groups = this.getGroups(indicator);
          for (let group = 0; group < groups; group++) {
            for (const parameter of indicator.parameters) {
              if (this.isGroupCellFilled(parameter, group)) {
                filled++;
              }
            }
          }
        } else {
          for (const parameter of indicator.parameters) {
            if (this.isSingleCellFilled(parameter)) {
              filled++;
            }
          }
        }
      }
      return filled;
    },
    getSectionValuesCount(sectionIndex) {
      let total = 0;
      const section = this.config.sections[sectionIndex];

      for (const indicator of section.indicators) {
        if (indicator.isGroup) {
          const groups = this.getGroups(indicator);
          total += indicator.parameters.length * groups;
        } else {
          total += indicator.parameters.length;
        }
      }
      return total;
    },
    getValuesByIndicator(indicator) {
      const ids = indicator.parameters.map(parameter => parameter.id)
      return this.values.filter(e => ids.includes(e.indicatorId))
    },
    async sendReport() {
      if (!this.canEditDraft) {
        return
      }
      this.report.status = 'SENT'
      this.report.lastModifiedBy = this.$user.username

      await saveForm(this.report)
      await this.initialize()
    },
    getLevelName() {
      if (this.report.cznId !== null) {
        return this.getCznNameByCznId(this.report.cznId)
      }
      if (this.report.regionCode !== null) {
        return this.getRegionNameByCode(this.report.regionCode)
      }
    },
    getRegionNameByCode(regionCode) {
      return this.$cznDepartmentsByRegionList.find(r => r.code === regionCode)?.name
    },
    getCznNameByCznId(cznId) {
      for (const region of this.$cznDepartmentsByRegionList) {
        const department = region.departments.find(c => c.id === cznId);
        if (department) {
          return department.name;
        }
      }
      return cznId;
    },
    truncateStr(str, n) {
      if (str.length > (n + 6)) {
        return str.substring(0, n - 3) + "..." + str.substring(str.length - 6, str.length)
      }
      return str
    },
    readArray(raw) {
      if (!raw) return [];
      try {
        const array = JSON.parse(raw);
        return Array.isArray(array) ? array : [String(array)];
      } catch {
        return [];
      }
    },
    formatValue(parameter, value) {
      if (value == null || value === "") {
        return '—'
      }
      if (parameter.type === 'DATE' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [y, m, d] = value.split('-')
        return `${d}.${m}.${y}`
      }
      return value
    }
  },
  filters: {
    dateFormat: function (date) {
      if (date == null || date === "") {
        return '—'
      }
      let mdate = new Date(date)
      let options = {timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric'}
      return mdate.toLocaleDateString('ru-RU', options)
    }
  },
  async beforeMount() {
    await this.initialize();
  }
}
</script>

<style scoped lang="scss">
h1 {
  display: flex;
  align-items: center;
  .badge {
    width: 152px;
    height: 60px;
    background: #E8E8E9;
    border: 1px solid #E8E8E9;
    border-radius: 4px;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: $cblack;
    margin: 0;
  }
  .v-progress-circular {
    margin-left: 20px;
  }
  .v-btn {
    margin-left: auto;
  }
}

.manual-link {
  margin: 20px 0;
  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    margin-bottom: 20px;
    .v-icon {
      color: #0033a0;
      margin-right: 10px;
    }
  }
}

.report-description {
  margin: 8px 0 4px;
  font-size: 15px;
  line-height: 1.45;
  color: #1C1C1F;

  ::v-deep > *:first-child {
    margin-top: 0;
  }

  ::v-deep > *:last-child {
    margin-bottom: 0;
  }

  ::v-deep p {
    margin: 0 0 0.5em;
  }

  ::v-deep ul,
  ::v-deep ol {
    margin: 0 0 0.5em;
    padding-left: 1.5em;
  }
}

.list {
  table {
    border-collapse: collapse;
    margin-bottom: 25px;
    th {
      border-bottom: 1px solid #E8E8E9;
    }
    td:nth-child(2),
    th:nth-child(2) {
      text-align: right;
    }
    td:first-child {
      span {
        font-size: 12px;
        color: #CF4520;
      }
    }
    td:nth-child(2) > div {
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      svg {
        margin-right: 8px;
        flex-shrink: 0;
        margin-top: 5px;
      }
    }
    tr:last-child td {
      border-bottom: 1px solid #E8E8E9;
    }
  }
}
.push-right {
  float: right;
  margin-top: 15px;
}

.v-progress-circular__info {
  font-size: 13px !important;
  text-align: center;
  width: 100%;
}

.group {
  background-color: #f4f4f4;
}

.group td {
  padding: 8px;
}
</style>

<style lang="scss">
@import "../../styles/main.scss";
</style>